import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import RichText from '@components/atoms/RichText';

const ReviewCard = ({
  data = {
    title: ``,
    date: ``,
    origin: ``,
    reviewer: ``,
    content: {}
  }
}) => {
  const { title, date, origin, reviewer, content } = data;

  return (
    <Box
      p="1.5rem"
      mb="0.5rem"
      borderRadius="0.313rem"
      borderColor="purple.100"
      borderWidth="1px"
      height="100%"
      display="flex"
      flexDirection="column">
      <Box as="p" pb="0.5rem" fontWeight="700" fontSize="md" color="gray.800">
        {title}
      </Box>
      <RichText
        data={content.data.content}
        pb="1rem"
        fontWeight="400"
        fontSize="sm"
        lineHeight="1.31rem"
      />
      <Flex
        marginTop="auto"
        alignItems="stretch"
        color="gray.600"
        fontWeight="400"
        fontSize="sm"
        lineHeight="1.313rem">
        <Box
          as="span"
          pos="relative"
          pr="1rem"
          _after={{
            content: `""`,
            marginTop: `-1px`,
            position: `absolute`,
            right: `0.5rem`,
            top: `50%`,
            width: `2px`,
            height: `2px`,
            background: `purple.100`
          }}>
          {reviewer}
        </Box>
        <Box
          as="span"
          pos="relative"
          pr="1rem"
          _after={{
            content: `""`,
            marginTop: `-1px`,
            position: `absolute`,
            right: `0.5rem`,
            top: `50%`,
            width: `2px`,
            height: `2px`,
            background: `purple.100`
          }}>
          {date}
        </Box>
        <Box as="span" pr="1rem">
          {origin}
        </Box>
      </Flex>
    </Box>
  );
};

export default ReviewCard;
